import React, {useState} from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { projectAuth } from '../firebase/config';
import { useNavigate } from 'react-router-dom'

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const onLogin = (e) => {
        e.preventDefault();
        signInWithEmailAndPassword(projectAuth, email, password)
            .then((userCredential) => {
                navigate("/")
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(errorCode, errorMessage)
            });

    }

    return(
        <>
            <main>
                <section>
                    <div className="container">
                        <div className="p-4 border m-5">
                            <h1>Přihlášení</h1>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="email-address" className="form-label">
                                        Email
                                    </label>
                                    <input
                                        id="email-address"
                                        name="email"
                                        type="email"
                                        required
                                        placeholder="Zadej email"
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="form-control"
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="password" className="form-label">
                                        Heslo
                                    </label>
                                    <input
                                        id="password"
                                        name="password"
                                        type="password"
                                        required
                                        placeholder="Zadej heslo"
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="form-control"
                                    />
                                </div>

                                <div>
                                    <button
                                        onClick={onLogin}
                                        className="btn btn-primary"
                                    >
                                        Přihlásit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}

export default Login